// Claim SPToken for all participants

import {useState, useEffect, useRef} from "react";
import { useParams } from 'react-router-dom';
import {
	Box,
	useToast,
	Button
} from "@chakra-ui/react";
import {
	participants,
	getReleasableByAccount,
	fromWei,
	format,
	SPTokenFactoryContract,
	getSPTClaimed,
	getReleasableForIP,
	getSPTokenAddress,
} from "../../utils/common";
import {
	SP_TOKEN_SYMBOL,
	ETHER_SCAN_URL
} from "../../config";
import { useAuth } from "../../contexts/AuthContext";
import ConfirmationProgress from "../../components/ConfirmationProgress";
import intl from "../../utils/intl";
// import {Shareholders} from "../Shareholders";

const ClaimSPTokenBody = (props) => {
	let params = useParams();
	const [claimables, setClaimables] = useState([]);
	const toast = useToast();
  const { currentAccount, setCurrentAccount, currentNetwork } = useAuth();
	const [ hiddenConfirmationProgress, setHiddenConfirmationProgress ] = useState(true);
	const [ confirmationProgressData, setConfirmationProgressData ] = useState({value: 5, message: intl.get("start"), step: 1});
	const [ spTokenAddress, setSPTokenAddress ] = useState('');
	const loaded = useRef(false);

	// DEBUG, for checking other account's releasable amount
	// setCurrentAccount('0xF0Ab3FD4bf892BcB9b40B9c6B5a05e02f3afe833');

	const getClaimableAmounts = (async() => {
		// console.log(currentAccount)
		if(currentAccount === undefined) return;
		let _claimables = [];
		let claimable = 0;
		for(let i = 1; i <= 8; i++) {
			if(i >= 4) claimable = await getReleasableByAccount(i, params.tokenId, currentAccount);
			else if(i <= 3) claimable = await getReleasableForIP(i, params.tokenId, currentAccount); // for IPOwner, IPAgent and IPIncentive
			const claimed = await getSPTClaimed(i, params.tokenId, currentAccount);
			_claimables.push({
				participantId: i,
				name: participants[i].name,
				claimable,
				claimed
			})
		}
		// console.log(_claimables);
		setClaimables(_claimables);
		setSPTokenAddress(await getSPTokenAddress(params.tokenId));
	});

	useEffect(() => {
		if(!loaded.current && currentAccount !== undefined && params.tokenId !== undefined) {
			getClaimableAmounts();
			return() => loaded.current = true;	
		}
	}, [currentAccount, currentNetwork])

	const bg = "#08152b";

	const showError = (msg) => {
		toast({
			title: intl.get("error"),
			description: msg,
			status: "error",
			duration: 4000,
			isClosable: true
		})
	}

	const showSuccess = (msg) => {
		toast({
			title: intl.get("success"),
			description: msg,
			status: "success",
			duration: 4000,
			isClosable: true
		})
	}

	const claim = async (id) => {
		if(params.tokenId === undefined) {
			showError('please_assign_token_id');
			return;
		}
		setHiddenConfirmationProgress(false);
		setConfirmationProgressData({step: '1/2', value: 10, message: intl.get("start")});
		// console.log(claimables[id].participantId, params.tokenId)
		try {
			const tx = await SPTokenFactoryContract().claim(
				claimables[id].participantId,
				params.tokenId
			);
			await tx.wait();
			setConfirmationProgressData({step: '2/2', value: 100, message: intl.get("claiming_payment")});
			showSuccess(intl.get("claim_success"));

			setTimeout(() => {
				setHiddenConfirmationProgress(true);
			}, 4000);	
		} catch (err) {
			showError(err.message);
			setHiddenConfirmationProgress(true);
		}
	}

	return(
		<Box>
		{currentAccount === undefined || claimables.length === 0 ? <></> :
		<Box mt={20}>
			<Box mt={10} w={"32%"} ml={"34%"} color={"white"}>
				{/* {intl.get("current_account") + ": " + currentAccount} */}
				<Box>{`SPToken ID: ${params.tokenId}`}</Box>
				<Box>{"SPToken Address: "}
					<a href={ETHER_SCAN_URL + 'address/' + spTokenAddress} target="_blank" rel="noreferrer">{spTokenAddress}</a>
				</Box>
			</Box>
			{claimables.map((v, i) => {
				if(v.claimable === undefined || (v.claimable * 1 === 0 && v.claimed * 1 === 0)) return(<Box key={i}></Box>);
				return(
					<Box key={i}>
						<Box
							bg={bg}
							w={"32%"}
							ml={"34%"}
							mt={8}
							p={5}
							borderRadius={10}
							border={"1px solid"}
							borderColor={bg}
							color={"white"}
						>
							<Box mb={3}>
								{v.name}
							</Box>
							<Box mb={3}>
								{intl.get("claimable") + ": " + format(fromWei(v.claimable), 4) + " " + SP_TOKEN_SYMBOL}
							</Box>
							<Box mb={3}>
							 	{intl.get("claimed") + ": " + format(fromWei(v.claimed), 4) + " " + SP_TOKEN_SYMBOL}
							</Box>
							{/* <Box mb={3}>
								<InputGroup size='md'>
									<InputLeftAddon children='USDT' color={"black"} />
									<Input placeholder='Claim amount' />
								</InputGroup>
							</Box> */}
							<Button disabled={v.claimable * 1 === 0} mt={3} size="md" w={"40%"} bg={"#815cd3"} onClick={() => claim(i)}>
								{intl.get("claim")}
							</Button>
						</Box>
					</Box>
				)
			})}
		</Box>}
		{/* <Box color={"white"} w={"32%"} ml={"34%"} mt={10}>
			<Shareholders/>
		</Box> */}
		{hiddenConfirmationProgress ? <></> :
		<Box color={"white"} w={"32%"} ml={"34%"}>
			<ConfirmationProgress 
				step={confirmationProgressData.step}
				value={confirmationProgressData.value}
				message={confirmationProgressData.message}
			/>
		</Box>}
		</Box>
	)
}

export default ClaimSPTokenBody;